import { render } from "./accountSetting.vue?vue&type=template&id=2a32dfa8&scoped=true"
import script from "./accountSetting.vue?vue&type=script&lang=js"
export * from "./accountSetting.vue?vue&type=script&lang=js"

import "./accountSetting.vue?vue&type=style&index=0&id=2a32dfa8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a32dfa8"]])

export default __exports__